import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { APP_ROUTES } from "@app/constants";
import { LocalStorageService } from "@app/services";
import { Observable } from "rxjs";

@Injectable()
export class SessionGuard implements CanActivate {
    constructor(
        private router: Router
    ) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

        if(LocalStorageService.getSession() != null) {
            return true
        }

        this.router.navigate([APP_ROUTES.LOGIN], {
            queryParams: {
                redirect: state.url
            }
        })
        return false
    }
}